import React, { useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

// Campo password con l'occhietto per mostrare o nascondere il testo
const PasswordInput = ({ value, onChange, placeholder, required, autoComplete, ...resto }) => {
  const [visibile, setVisibile] = useState(false);
  return (
    <InputGroup>
      <Form.Control
        type={visibile ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoComplete={autoComplete}
        {...resto}
      />
      <Button
        variant="outline-secondary"
        type="button"
        onClick={() => setVisibile((v) => !v)}
        title={visibile ? 'Nascondi la password' : 'Mostra la password'}
        aria-label={visibile ? 'Nascondi la password' : 'Mostra la password'}
        tabIndex={-1}
      >
        <FontAwesomeIcon icon={visibile ? faEyeSlash : faEye} />
      </Button>
    </InputGroup>
  );
};

export default PasswordInput;
